import {$document, APP_NAME} from '../utils/environment';
import * as CookieConsent from 'vanilla-cookieconsent';
import AbstractModule from './AbstractModule';

const MODULE_NAME = 'CookieConsent';
const EVENT_NAMESPACE = `${APP_NAME}.${MODULE_NAME}`;

const EVENT = {
    CLICK: `click.${EVENT_NAMESPACE}`
};

export default class extends AbstractModule {
    constructor(options) {
        super(options);

        try {
            this.config = JSON.parse(this.$el.attr('data-cookie-consent-config'));
        } catch (err) {
            console.warn(err.message);
        }

        $document.on('click', '[data-cookie-consent="show-preferences"]', () => this.showPreferences());
        this.$el.on(EVENT.CLICK, '[data-cookie-consent="hide"]', (e) => this.hideModal())
    }

    init() {
        // Set events and such
        if (!this.config.categories || Object.keys(this.config.categories).length === 0) {
            console.warn('[CookieConsent]', 'No categories configured.');
            return;
        }

        this.config.categories = this.prepareCategories(this.config.categories);

        CookieConsent.run(Object.assign({
            onConsent: () => {
                this.toggleCategoryAnalytics();
            },
            onChange: ({ changedCategories }) => {
                if (changedCategories.includes('analytics')) {
                    this.toggleCategoryAnalytics();
                }
            },
        }, this.config));
    }

    toggleCategoryAnalytics() {
        const isAccepted = CookieConsent.acceptedCategory('analytics');

        window.gtag('consent', 'update', {
            'analytics_storage': (isAccepted ? 'granted' : 'denied'),
        });
    }

    prepareCategories(categories)
    {
        for (const [ categoryName, categoryData ] of Object.entries(categories)) {
            if (
                categoryData?.autoClear?.cookies &&
                Array.isArray(categoryData.autoClear.cookies) &&
                categoryData.autoClear.cookies.length > 0
            ) {
                categoryData.autoClear.cookies.map((cookie) => {
                    if (
                        cookie?.name &&
                        typeof cookie.name === 'string'
                    ) {
                        const found = cookie.name.match(/^\/(.+)\/([a-z]+)?$/);
                        if (found) {
                            cookie.name = new RegExp(found[1], found[2]);
                        }
                    }

                    return cookie;
                });

                categories[categoryName].autoClear.cookies = categoryData.autoClear.cookies;
            }
        }

        return categories;
    }

    showPreferences()
    {
        CookieConsent.showPreferences();
    }

    hideModal()
    {
        CookieConsent.hidePreferences();
        CookieConsent.hide();
    }

    destroy() {
        super.destroy();
        this.$el.off(`.${EVENT_NAMESPACE}`);
    }
}
